import {
  HeaderImage,
  ImageContainer,
  ImpactShopHeroContainer,
  TextWrapper,
  TitleWrapper,
  WhiteTypography,
} from "./ImpactShopHero.styles";

export const ImpactShopHero = () => {
  return (
    <ImpactShopHeroContainer>
      <ImageContainer position="left">
        <HeaderImage
          gridArea="img1"
          imageUrlDesktop="/images/app/headers/impact-shop-header-renewables-desktop.svg"
          imageUrlMobile="/images/app/headers/impact-shop-header-renewables-mobile.svg"
          position="left"
          mobileHeight={155}
          mobileWidth={160}
          mobileLeftMargin={20}
        />
      </ImageContainer>

      <TextWrapper isExtraSmall>
        <TitleWrapper>
          <WhiteTypography as="h1" use="featureTitle">
            Impact shop
          </WhiteTypography>
        </TitleWrapper>
        <WhiteTypography as="h2" use="subtitle2">
          Fund diverse, best-in-class projects & impact funds to address the
          climate crisis and restore nature
        </WhiteTypography>
      </TextWrapper>
      <ImageContainer position="right">
        <HeaderImage
          gridArea="img2"
          imageUrlDesktop="/images/app/headers/impact-shop-header-forest-desktop.svg"
          imageUrlMobile="/images/app/headers/impact-shop-header-forest-mobile.svg"
          position="right"
          mobileWidth={180}
          mobileHeight={200}
        />
      </ImageContainer>
    </ImpactShopHeroContainer>
  );
};
